// Mock data for the prototype
const COMPANIES = [
  { id: 'c1', name: 'Northwind Industrial', domain: 'northwind-industrial.com', industry: 'Industrial Mfg', sector: 'HVAC', revenue: 84_300_000, ebitda: 12_900_000, employees: 412, hq: 'Cincinnati, OH', stage: 'Diligence', owner: 'A. Mehta', logo: '#2A6FDB' },
  { id: 'c2', name: 'Coastline Logistics', domain: 'coastline-logistics.com', industry: 'Logistics', sector: 'Last-mile', revenue: 142_600_000, ebitda: 18_400_000, employees: 980, hq: 'Long Beach, CA', stage: 'IOI', owner: 'A. Mehta', logo: '#1F8A5B' },
  { id: 'c3', name: 'Atlas Sealants', domain: 'atlassealants.com', industry: 'Specialty Chem', sector: 'Coatings', revenue: 38_200_000, ebitda: 7_100_000, employees: 188, hq: 'Houston, TX', stage: 'LOI', owner: 'J. Park', logo: '#B5571F' },
  { id: 'c4', name: 'Bridgepoint Mechanical', domain: 'bridgepointmech.com', industry: 'Industrial Svc', sector: 'Plumbing', revenue: 67_500_000, ebitda: 9_800_000, employees: 305, hq: 'Pittsburgh, PA', stage: 'Sourcing', owner: 'L. Chen', logo: '#5C3FA8' },
  { id: 'c5', name: 'Greenfield Foods', domain: 'greenfield-foods.com', industry: 'Food & Bev', sector: 'Frozen', revenue: 215_000_000, ebitda: 28_400_000, employees: 1240, hq: 'Madison, WI', stage: 'Sourcing', owner: 'L. Chen', logo: '#2F7A3D' },
  { id: 'c6', name: 'Helix Diagnostics', domain: 'helixdx.com', industry: 'Healthcare', sector: 'Lab Svc', revenue: 51_900_000, ebitda: 11_200_000, employees: 240, hq: 'Boston, MA', stage: 'IOI', owner: 'A. Mehta', logo: '#0D7B7B' },
  { id: 'c7', name: 'Sentinel Roofing', domain: 'sentinelroofing.com', industry: 'Building Prod', sector: 'Roofing', revenue: 28_700_000, ebitda: 5_800_000, employees: 145, hq: 'Phoenix, AZ', stage: 'Sourcing', owner: 'J. Park', logo: '#A33A3A' },
  { id: 'c8', name: 'Verde Pet Health', domain: 'verdepethealth.com', industry: 'Consumer', sector: 'Pet Care', revenue: 96_400_000, ebitda: 15_300_000, employees: 410, hq: 'Austin, TX', stage: 'Diligence', owner: 'L. Chen', logo: '#3B7A36' },
  { id: 'c9', name: 'Polaris Components', domain: 'polariscomp.com', industry: 'Industrial Mfg', sector: 'Aerospace', revenue: 178_300_000, ebitda: 31_200_000, employees: 720, hq: 'Wichita, KS', stage: 'LOI', owner: 'A. Mehta', logo: '#1E4F7A' },
  { id: 'c10', name: 'Cascade Specialty', domain: 'cascadespecialty.com', industry: 'Specialty Chem', sector: 'Adhesives', revenue: 44_100_000, ebitda: 8_200_000, employees: 215, hq: 'Tacoma, WA', stage: 'Sourcing', owner: 'J. Park', logo: '#7A5C1E' },
  { id: 'c11', name: 'Beacon Software', domain: 'beaconsoftware.com', industry: 'Software', sector: 'Vertical SaaS', revenue: 31_800_000, ebitda: 6_900_000, employees: 165, hq: 'Toronto, ON', stage: 'IOI', owner: 'L. Chen', logo: '#3D5AB8' },
  { id: 'c12', name: 'Ironclad Castings', domain: 'ironcladcastings.com', industry: 'Industrial Mfg', sector: 'Foundry', revenue: 58_400_000, ebitda: 8_700_000, employees: 280, hq: 'Birmingham, AL', stage: 'Sourcing', owner: 'A. Mehta', logo: '#3F3F3F' },
];

const STAGES = [
  { key: 'sourcing',  label: 'Sourcing',     hue: 'slate',  prob: 5 },
  { key: 'ioi',       label: 'IOI Submitted', hue: 'teal',  prob: 25 },
  { key: 'mgmt',      label: 'Mgmt Meeting',  hue: 'violet',prob: 45 },
  { key: 'loi',       label: 'LOI Signed',    hue: 'amber', prob: 70 },
  { key: 'diligence', label: 'Diligence',     hue: 'blue',  prob: 85 },
  { key: 'closing',   label: 'Closing',       hue: 'green', prob: 95 },
];

const DEALS = [
  { id: 'd1', name: 'Northwind — Buyout', target: 'c1', stage: 'diligence', size: 220_000_000, multiple: '8.2x', sector: 'HVAC',     owner: 'A. Mehta', closeBy: 'Q3 2026', updated: '2h ago', sponsor: 'Bridgemark Capital', irr: 23.4, healthScore: 86, stale: false },
  { id: 'd2', name: 'Coastline — Add-on', target: 'c2', stage: 'ioi',       size: 410_000_000, multiple: '7.8x', sector: 'Logistics',owner: 'A. Mehta', closeBy: 'Q4 2026', updated: '1d ago', sponsor: 'Pinecrest Holdings',  irr: 19.2, healthScore: 72, stale: false },
  { id: 'd3', name: 'Atlas — Sell-side',  target: 'c3', stage: 'loi',       size: 78_000_000,  multiple: '11.0x',sector: 'Coatings', owner: 'J. Park',  closeBy: 'Jul 2026',updated: '3h ago', sponsor: 'House',                irr: 31.0, healthScore: 92, stale: false },
  { id: 'd4', name: 'Bridgepoint — Carveout', target: 'c4', stage: 'sourcing', size: 165_000_000, multiple: '7.0x', sector: 'Plumbing', owner: 'L. Chen', closeBy: '—',     updated: '5d ago', sponsor: '—',                  irr: null, healthScore: 41, stale: true },
  { id: 'd5', name: 'Greenfield — Platform', target: 'c5', stage: 'sourcing', size: 720_000_000, multiple: '9.5x', sector: 'Frozen',  owner: 'L. Chen',  closeBy: '—',     updated: '8d ago', sponsor: '—',                  irr: null, healthScore: 58, stale: true },
  { id: 'd6', name: 'Helix — Recap',       target: 'c6', stage: 'mgmt',     size: 130_000_000, multiple: '10.2x',sector: 'Lab Svc',  owner: 'A. Mehta', closeBy: 'Sep 2026',updated: '6h ago', sponsor: 'Riverbend Partners',  irr: 26.8, healthScore: 79, stale: false },
  { id: 'd7', name: 'Polaris — Take-private', target: 'c9', stage: 'loi',  size: 980_000_000, multiple: '8.9x', sector: 'Aerospace',owner: 'A. Mehta', closeBy: 'Q1 2027', updated: '12h ago',sponsor: 'Bridgemark Capital',  irr: 21.6, healthScore: 88, stale: false },
  { id: 'd8', name: 'Verde — Dividend Recap', target: 'c8', stage: 'diligence', size: 240_000_000, multiple: '12.4x',sector: 'Pet Care', owner: 'L. Chen', closeBy: 'Aug 2026', updated: '1h ago', sponsor: 'Riverbend Partners', irr: 28.9, healthScore: 90, stale: false },
];

const ACTIVITIES = [
  { id: 'a1', when: 'Today, 10:24', who: 'A. Mehta',  type: 'note',   subject: 'Mgmt presentation went well — CEO confident on FY26 plan' },
  { id: 'a2', when: 'Today, 09:10', who: 'Atlas AI',  type: 'agent',  subject: 'Valuation refreshed: 8.0–8.6x EV/EBITDA range' },
  { id: 'a3', when: 'Yesterday',   who: 'L. Chen',    type: 'call',   subject: 'Intro call with CFO — discussed working capital adj.' },
  { id: 'a4', when: '2d ago',      who: 'J. Park',    type: 'email',  subject: 'NDA executed; data room access granted' },
  { id: 'a5', when: '4d ago',      who: 'Atlas AI',   type: 'agent',  subject: 'QofE flag: customer concentration > 22% (top 3)' },
  { id: 'a6', when: '6d ago',      who: 'A. Mehta',   type: 'meeting',subject: 'IOI strategy with sponsor; aligned on $220M cap' },
];

const PEOPLE = [
  { id: 'p1', name: 'Maria Donovan', title: 'CEO',      company: 'Northwind Industrial', email: 'maria@northwind-industrial.com', phone: '+1 513-555-0142', tier: 'Champion' },
  { id: 'p2', name: 'Greg Park',     title: 'CFO',      company: 'Northwind Industrial', email: 'greg@northwind-industrial.com', phone: '+1 513-555-0188', tier: 'Decision-maker' },
  { id: 'p3', name: 'Anita Vohra',   title: 'COO',      company: 'Northwind Industrial', email: 'anita@northwind-industrial.com',phone: '+1 513-555-0167', tier: 'Influencer' },
  { id: 'p4', name: 'Sasha Rivera',  title: 'GP',       company: 'Bridgemark Capital',   email: 'sasha@bridgemarkcap.com',       phone: '+1 212-555-0193', tier: 'Sponsor' },
];

// Hue token map -> css custom properties
const HUE = {
  slate:  { bg: 'var(--slate-bg)',  fg: 'var(--slate-fg)',  dot: 'oklch(0.55 0.01 270)' },
  blue:   { bg: 'var(--accent-soft)', fg: 'var(--accent-text)', dot: 'oklch(0.55 0.14 255)' },
  teal:   { bg: 'var(--teal-bg)',   fg: 'var(--teal-fg)',   dot: 'oklch(0.55 0.10 200)' },
  violet: { bg: 'var(--violet-bg)', fg: 'var(--violet-fg)', dot: 'oklch(0.55 0.13 295)' },
  amber:  { bg: 'var(--amber-bg)',  fg: 'var(--amber-fg)',  dot: 'oklch(0.65 0.13 75)' },
  green:  { bg: 'var(--green-bg)',  fg: 'var(--green-fg)',  dot: 'oklch(0.55 0.10 155)' },
  rose:   { bg: 'var(--rose-bg)',   fg: 'var(--rose-fg)',   dot: 'oklch(0.55 0.14 25)' },
};

const fmtMoney = (n) => {
  if (n == null) return '—';
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n}`;
};
const fmtNum = (n) => n == null ? '—' : n.toLocaleString();

// Render an ISO date (or null) as "MMM d, yyyy" — short and unambiguous.
const fmtDate = (iso) => {
  if (!iso) return '—';
  // Bare YYYY-MM-DD parses as UTC midnight, which renders as the previous
  // day anywhere west of Greenwich — pin date-only values to local midnight.
  const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

// Parse `{{key}}` placeholders from a formula. Returns array of unique keys.
const _FORMULA_PLACEHOLDER = /\{\{\s*([\w.]+)\s*\}\}/g;
const formulaRefs = (formula) => {
  if (!formula) return [];
  const out = new Set();
  let m;
  _FORMULA_PLACEHOLDER.lastIndex = 0;
  while ((m = _FORMULA_PLACEHOLDER.exec(formula)) !== null) out.add(m[1]);
  return [...out];
};

// Return the subset of formula refs that have null/empty values on a record.
// Used by the "Needs filling" badge to tell the user which source fields are
// missing on a row where the formula evaluated to null.
const missingFormulaRefs = (def, raw) => {
  if (!raw || !def || def.field_type !== 'formula') return [];
  const formula = (def.field_config || {}).formula || '';
  return formulaRefs(formula).filter((k) => {
    const v = raw[k];
    return v === null || v === undefined || v === '';
  });
};

// Format a single computed field value for table display, honoring the
// field_config that was set when the field was defined.
const formatComputed = (def, value) => {
  if (value == null || value === '') return '—';
  const cfg = def.field_config || {};
  if (def.field_type === 'currency') {
    const n = Number(value);
    if (Number.isFinite(n)) return fmtMoney(n);
    return String(value);
  }
  if (def.field_type === 'number') {
    const n = Number(value);
    if (Number.isFinite(n)) {
      const decimals = cfg.decimals != null ? cfg.decimals : 2;
      return n.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
        + (cfg.suffix || '');
    }
  }
  if (def.field_type === 'boolean') {
    return value ? '✓' : '—';
  }
  return String(value);
};

// ── API ↔ UI shape adapters ────────────────────────────────────────────────
// The FastAPI backend has narrower schemas than the prototype's mock objects.
// Adapters pad missing fields with null/derivations so the UI keeps rendering.

const STAGE_KEYS = ['sourcing', 'ioi', 'mgmt', 'loi', 'diligence', 'closing'];
const normalizeStage = (raw) => {
  if (!raw) return 'sourcing';
  const s = String(raw).toLowerCase();
  if (STAGE_KEYS.includes(s)) return s;
  if (s.includes('sourc')) return 'sourcing';
  if (s.includes('ioi')) return 'ioi';
  if (s.includes('mgmt') || s.includes('management')) return 'mgmt';
  if (s.includes('loi')) return 'loi';
  if (s.includes('dilig')) return 'diligence';
  if (s.includes('clos')) return 'closing';
  if (s.includes('won')) return 'closing';
  return 'sourcing';
};

// stable hash → hex color for company logo dot
const hashColor = (str) => {
  let h = 0;
  for (let i = 0; i < (str || '').length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  const palette = ['#2A6FDB','#1F8A5B','#B5571F','#5C3FA8','#2F7A3D','#0D7B7B','#A33A3A','#3B7A36','#1E4F7A','#7A5C1E','#3D5AB8','#3F3F3F'];
  return palette[Math.abs(h) % palette.length];
};
window.hashColor = hashColor;

const stripProtocol = (url) =>
  (url || '').replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/$/, '');

const relativeTime = (iso) => {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '—';
  const diff = (Date.now() - then) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 14) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
};

// ── Record created / last-modified dates ──────────────────────────────────
// On every DealCloud-mirrored table (engagements, companies, contacts, notes)
// Atlas's own created_at/updated_at describe the SYNC, not the record: prod
// created_at lands on ~40 distinct backfill days across hundreds of thousands
// of rows, and updated_at is rewritten on effectively every pass (engagements:
// one single distinct day for all 10,130 rows). DealCloud's dc_created_at /
// dc_modified_at are the real dates — ~99.9% populated — so every grid reads
// those, falling back to the Atlas value only for rows Atlas itself owns.
const recordCreated  = (r) => (r && (r.dc_created_at  || r.created_at)) || null;
const recordModified = (r) => (r && (r.dc_modified_at || null)) || null;
// True when the created date came from Atlas rather than DealCloud — the grids
// render those dimmer and say so in the tooltip instead of passing an Atlas
// backfill timestamp off as a business date.
const recordCreatedIsAtlas = (r) => Boolean(r && !r.dc_created_at && r.created_at);

const adaptCompany = (c) => ({
  id:             c.id,
  name:           c.name,
  domain:         stripProtocol(c.website),
  dealcloudId:    c.dealcloud_id || null,
  lastSyncedAt:   c.last_synced_at || null,
  updatedAt:      c.updated_at || null,
  industry:       c.industry_name || '—',
  sector:         c.industry_name || '—',
  revenue:        c.revenue_est,
  ebitda:         c.ebitda_est,
  // Derived touchpoint tally (migration 089, hourly recompute) — excludes
  // 'Next Action' notes and future calendar occurrences.
  interactions:      c.interaction_count ?? 0,
  lastInteractionAt: c.last_interaction_at || null,
  webVisits:         c.web_visit_count ?? 0,
  lastWebVisitAt:    c.last_web_visit_at || null,
  employees:      null,
  hq:             [c.hq_city, c.hq_state].filter(Boolean).join(', ') || '—',
  stage:          'Sourcing',
  owner:          c.assigned_user_name || '—',
  team:           c.assigned_team_name || null,
  pipelineState:  c.pipeline_state || 'lead_pool',
  // Mirrors DealCloud's TargetTrackerStage; auto-pre-cleaned by the signal
  // pipeline. Free text, may be 'Closed', 'Outreach', 'Progressing', etc.
  trackerStage:   c.tracker_stage,
  // Stage-progress evidence — { intro_or_ds_call: { reached, evidence, … }, … }
  signals:        c.signals || {},
  industryId:     c.industry_id,
  // Lead source (142): channel + event + the lead's own date.
  leadSource:      c.lead_source_name || '—',
  leadSourceId:    c.lead_source_id || null,
  leadSourceGroup: c.lead_source_group || null,
  leadEvent:       c.lead_event_name || null,
  leadEventId:     c.lead_event_id || null,
  leadSourceAt:    c.lead_source_at || null,
  computed:       c.computed || {},
  _raw:           c,
  logo:           hashColor(c.name || c.id),
});

const adaptEngagement = (e) => ({
  id:           e.id,
  name:         e.name,
  target:       e.company_id,
  targetName:   e.company_name,
  // Primary contact at the linked company — the grid's "Contact" column.
  // Server-derived (decision-makers first, then most recent interaction)
  // unless the user pinned one on the engagement (contactPinned).
  contactId:    e.primary_contact_id || null,
  contactName:  e.primary_contact_name || null,
  contactPinned: !!e.primary_contact_pinned,
  // Details for that same contact — the opt-in "Contact email" / "Contact
  // phone" columns. They follow the pick above, so re-pinning swaps them.
  contactEmail: e.primary_contact_email || null,
  contactPhone: e.primary_contact_phone || null,
  contactTitle: e.primary_contact_title || null,
  // How many contacts the company has; >1 means the picker has a real choice.
  contactCount: e.company_contact_count || 0,
  stage:        e.stage_slug || 'sourcing',
  stageName:    e.stage_name,
  stageCategory:e.stage_category,
  probability:  e.stage_probability,
  exitName:     e.exit_name,
  onHold:       e.on_hold,
  onHoldReason: e.on_hold_reason || null,
  holdCheckinCadence: e.hold_checkin_cadence || null,
  size:         e.estimated_fees,
  weighted:     e.weighted_fees,
  reportedRevenue: e.reported_revenue,
  reportedEbitda:  e.reported_ebitda,
  // DealCloud's engagement-level Reported* fields are sparsely populated; the
  // numbers usually live on the linked Company instead. Surface those so the
  // UI can fall back when reported_* is null.
  companyRevenueEst: e.company_revenue_est,
  companyEbitdaEst:  e.company_ebitda_est,
  // Linked company's website — the grid's opt-in "Website" column. Stored
  // protocol-stripped, the same shape the Companies grid renders and exports.
  companyDomain:     stripProtocol(e.company_website),
  // Hot score (202609161000): the deal's manual 1–10 priority, null = not scored.
  hotScore:          e.hot_score ?? null,
  multiple:     null,
  sector:       e.industry_name || '—',
  // Lead source (142), inherited from the company.
  leadSource:   e.lead_source_name || '—',
  leadSourceId: e.lead_source_id || null,
  leadSourceGroup: e.lead_source_group || null,
  leadEvent:    e.lead_event_name || null,
  leadEventId:  e.lead_event_id || null,
  owner:        e.dealmaker_name || '—',
  associate:    e.associate_name,
  // Deal team (202609151200) — everyone working the deal, per-deal. Ids and
  // names arrive already paired and in stored order; keep them that way so
  // the chips don't reshuffle.
  dealTeam:      e.deal_team || [],
  dealTeamNames: e.deal_team_names || [],
  // Phase A — DealCloud-native dates + archive state.
  // Prefer the server's derived `live_since` (earliest of LiveEngagementDate
  // and the first linked note) — DealCloud's raw field often points at recent
  // stage changes rather than when the engagement actually started.
  estCloseDate:    e.estimated_close_date,
  closedDate:      e.closed_engagement_date,
  liveDate:        e.live_since || e.live_engagement_date,
  lastActivityAt:  e.last_activity_at || null,  // derived from latest linked note
  closingProcessDate: e.closing_process_date,
  totalFeesInvoiced:  e.total_fees_invoiced,
  totalFeesReceived:  e.total_fees_received,
  targetCompanies: Array.isArray(e.target_companies) ? e.target_companies : [],
  winningBuyerEngagementId: e.winning_buyer_engagement_id || null,
  // Buyer shells only: the seller deal this pursuit belongs to (migration 048).
  sellerEngagementId:   e.seller_engagement_id || null,
  sellerEngagementName: e.seller_engagement_name || null,
  // Verbatim DealCloud stage (migration 050) — buyer shells' real funnel.
  // Buyer shells: the stage an Atlas edit is being pushed as, else DC's own.
  dcStage:         e.pursuit_stage || e.dc_stage || null,
  archived:        Boolean(e.is_archived),
  archivedAt:      e.archived_at || null,
  archivedReason:  e.archived_reason || null,
  noteCount:       e.note_count || 0,
  // Denormalized touchpoint tally (migration 089) — like noteCount but
  // excludes 'Next Action' + future occurrences, and server-sortable.
  interactions:      e.interaction_count ?? 0,
  lastInteractionAt: e.last_interaction_at || null,
  // Newest linked note (engagement + company-level) — grid "Latest note" col.
  latestNoteAt:      e.latest_note_at || null,
  latestNoteTitle:   e.latest_note_title || null,
  latestNotePreview: e.latest_note_preview || null,
  latestNoteSubtype: e.latest_note_subtype || null,
  // Soonest upcoming calendar event on the deal's company — "Next meeting".
  nextMeetingAt:        e.next_meeting_at || null,
  nextMeetingTitle:     e.next_meeting_title || null,
  nextMeetingAttendees: e.next_meeting_attendees || [],
  nextMeetingAllDay:    Boolean(e.next_meeting_all_day),
  buyerCount:      e.interested_buyer_count || 0,
  // A closing is on file (deal_closings) — the detail payload only; null on
  // list rows, which don't say.
  hasClosing:      e.has_closing ?? null,
  dealcloudId:     e.dealcloud_id || null,
  lastSyncedAt:    e.last_synced_at || null,
  updatedAt:       e.updated_at || null,
  // Existing fields below
  closeBy:      e.estimated_close_date || e.next_action_date || '—',
  updated:      e.last_stage_update ? relativeTime(e.last_stage_update) : '—',
  nextActionNotes: e.next_action_notes,
  sponsor:      e.product_category || '—',
  irr:          null,
  healthScore:  null,
  stale:        Boolean(e.exit_id),
  type:         e.engagement_type,
  computed:     e.computed || {},
  _raw:         e,
});

const adaptContact = (p, companyById = {}) => ({
  id: p.id,
  name: [p.first_name, p.last_name].filter(Boolean).join(' ') || '—',
  title: p.title || '—',
  // Prefer the server-joined company_name (always present); fall back to a
  // caller-provided lookup map for callers that have already loaded companies
  // (kept for backward-compat with adaptCompany-merging callers).
  company: p.company_name || companyById[p.company_id]?.name || '—',
  email: p.email || '',
  phone: p.phone || '',
  roles: p.roles || [],
  // Derived touchpoint tally (migration 089, hourly recompute).
  interactions:      p.interaction_count ?? 0,
  lastInteractionAt: p.last_interaction_at || null,
  webVisits:         p.web_visit_count ?? 0,
  lastWebVisitAt:    p.last_web_visit_at || null,
  tier: '—',
  dealcloudId:   p.dealcloud_id || null,
  lastSyncedAt:  p.last_synced_at || null,
  updatedAt:     p.updated_at || null,
  _raw: p,
});

const adaptActivity = (a) => ({
  id: a.id,
  when: relativeTime(a.happened_at),
  who: a.created_by || '—',
  type: (a.activity_type || 'note').toLowerCase(),
  subject: a.notes || a.activity_type || '—',
});

// ── Loaders — try API, fall back to mock if unreachable ────────────────────

const unwrap = (paged) => (Array.isArray(paged) ? paged : paged?.items || []);

// A 403 is the server answering "not for you" — a deal guest's boot, a page
// the role can't open — not an outage: it never flips the app to demo data,
// and the loader hands back an empty result instead of fixtures.
const isForbidden = (e) => /^403\b/.test((e && e.message) || '');

const AtlasData = {
  __mode: 'mock', // flips to 'live' once any loader succeeds
  __listeners: new Set(),
  onModeChange(fn) { this.__listeners.add(fn); return () => this.__listeners.delete(fn); },
  __setMode(m) {
    if (this.__mode === m) return;
    this.__mode = m;
    this.__listeners.forEach((fn) => { try { fn(m); } catch {} });
  },

  async loadCompanies(opts = {}) {
    try {
      // 500 default keeps first-paint fast for the team view. Pages that
      // genuinely need more pass `limit: …` in opts (e.g. CSV export).
      // Real pagination is the next step; this is the temporary cap.
      const data = await window.AtlasApi.listCompanies({ limit: 500, my_team: true, ...opts });
      this.__setMode('live');
      return unwrap(data).map(adaptCompany);
    } catch (e) {
      console.warn('[atlas] companies fallback to mock:', e.message);
      if (isForbidden(e)) return [];
      this.__setMode('mock');
      return COMPANIES;
    }
  },

  async loadDeals(opts = {}) {
    try {
      // 500 default — was 5000, which dragged the engagements list view to
      // 6-20s. Callers that need the full set pass `limit: …` explicitly.
      const data = await window.AtlasApi.listEngagements({ limit: 500, my_team: true, ...opts });
      this.__setMode('live');
      return unwrap(data).map(adaptEngagement);
    } catch (e) {
      console.warn('[atlas] deals fallback to mock:', e.message);
      if (isForbidden(e)) return [];
      this.__setMode('mock');
      return DEALS;
    }
  },

  async loadStages() {
    try {
      const data = await window.AtlasApi.listStages();
      this.__setMode('live');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.warn('[atlas] stages fallback to mock:', e.message);
      if (isForbidden(e)) return null;
      this.__setMode('mock');
      return null;
    }
  },

  async loadFieldDefinitions(object_type) {
    try {
      const data = await window.AtlasApi.listFieldDefinitions(object_type);
      this.__setMode('live');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.warn('[atlas] field defs fallback:', e.message);
      if (isForbidden(e)) return [];
      this.__setMode('mock');
      return [];
    }
  },

  async loadPeople() {
    try {
      // 1000 contacts is enough for first paint of the People view —
      // anything more should use server-side filter/search, not bulk load.
      const [contacts, comps] = await Promise.all([
        window.AtlasApi.listContacts({ limit: 1000, my_team: true }),
        window.AtlasApi.listCompanies({ limit: 500,  my_team: true }),
      ]);
      const byId = Object.fromEntries(unwrap(comps).map((c) => [c.id, c]));
      this.__setMode('live');
      return unwrap(contacts).map((p) => adaptContact(p, byId));
    } catch (e) {
      console.warn('[atlas] people fallback to mock:', e.message);
      if (isForbidden(e)) return [];
      this.__setMode('mock');
      return PEOPLE;
    }
  },

  async loadTeamMembers() {
    try {
      const data = await window.AtlasApi.listTeamMembers();
      this.__setMode('live');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.warn('[atlas] team members fallback to mock:', e.message);
      if (isForbidden(e)) return [];
      this.__setMode('mock');
      return null; // settings pane falls back to its bundled MEMBERS array
    }
  },

  async loadActivities() {
    try {
      const data = await window.AtlasApi.listActivities({ limit: 50 });
      this.__setMode('live');
      return unwrap(data).map(adaptActivity);
    } catch (e) {
      console.warn('[atlas] activities fallback to mock:', e.message);
      if (isForbidden(e)) return [];
      this.__setMode('mock');
      return ACTIVITIES;
    }
  },

  async loadDashboardCounts() {
    try {
      const counts = await window.AtlasApi.dashboardCounts({ my_team: true });
      this.__setMode('live');
      return counts;
    } catch (e) {
      console.warn('[atlas] dashboard fallback to mock:', e.message);
      if (isForbidden(e)) return {};
      this.__setMode('mock');
      return {
        companies: COMPANIES.length,
        contacts:  PEOPLE.length,
        engagements: DEALS.length,
        notes: 0,
        team: 4,
      };
    }
  },

  async loadAgentCatalog() {
    try {
      const data = await window.AtlasApi.agentCatalog();
      this.__setMode('live');
      return data;
    } catch (e) {
      console.warn('[atlas] agents fallback to mock:', e.message);
      if (isForbidden(e)) return null;
      this.__setMode('mock');
      return null;
    }
  },

  async loadWorkspaces() {
    try {
      const data = await window.AtlasApi.agentWorkspaces();
      this.__setMode('live');
      return data;
    } catch (e) {
      console.warn('[atlas] workspaces fallback to mock:', e.message);
      if (isForbidden(e)) return [];
      this.__setMode('mock');
      return [];
    }
  },
};

// Expose adapters so views can re-shape responses without going through a loader.
AtlasData.__adaptEngagement = adaptEngagement;
AtlasData.__adaptCompany    = adaptCompany;
AtlasData.__adaptContact    = adaptContact;

Object.assign(window, {
  COMPANIES, STAGES, DEALS, ACTIVITIES, PEOPLE, HUE,
  fmtMoney, fmtNum, fmtDate, formatComputed, missingFormulaRefs, relativeTime, normalizeStage,
  recordCreated, recordModified, recordCreatedIsAtlas,
  AtlasData,
});
